<template>
  <review-card title="Cromossomos(as)">
    <template #title>
      <v-card-title class="d-flex align-center justify-center justify-sm-start">
        <v-icon large class="mr-2" color="orange">warning</v-icon>
        <h5>{{ therapyTemplate.diagnosticTitle }}</h5>
      </v-card-title>
    </template>
    <div class="pa-3 body-2" v-html="formattedDescription"></div>
  </review-card>
</template>

<script>
import DOMPurify from "dompurify";

export default {
  name: "TherapyTemplateDisclaimer",
  props: {
    therapyTemplate: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDescription() {
      if (!this.therapyTemplate.diagnosticDescription) {
        return "";
      }
      return DOMPurify.sanitize(
        this.therapyTemplate.diagnosticDescription
          .split("\n")
          .filter((line) => line.trim() !== "")
          .map((paragraph) => `<p>${paragraph}</p>`)
          .join("")
      );
    },
  },
};
</script>

<style scoped></style>
